document.addEventListener('click', (e) => {
  const btn = e.target.closest?.('.quick-add__button');
  if (!btn || btn.closest('.quick-add-modal')) return;
  const card = btn.closest('product-card, .product-card');
  const url = card?.querySelector('a[href*="/products/"]')?.href;
  if (!url) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  window.location.href = url;
}, true);
